module.exports = __webpack_public_path__ + "061225e436f007768d3d2862e6f89c4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./web/images/faces/sydney.jpg
// module id = 606
// module chunks = 0